<template>
  <div class="w-full">
    <div class="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <!-- Profil Özeti -->
      <div class="p-4 border-b border-gray-100">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center"
          >
            <UIcon name="i-heroicons-user" class="w-5 h-5 text-orange-600" />
          </div>
          <div>
            <h3 class="text-sm font-medium text-gray-800">
              {{ authStore.user?.name || 'Kullanıcı' }}
            </h3>
            <p class="text-xs text-gray-500">{{ authStore.user?.email }}</p>
          </div>
        </div>
      </div>

      <!-- Menü Linkleri -->
      <div class="p-2">
        <NuxtLink to="/hesap/siparislerim">
          <div
            class="flex items-center gap-2 p-2 rounded-lg duration-200 hover:bg-gray-50"
            :class="{
              'bg-orange-50 text-orange-600':
                useRoute().fullPath === '/hesap/siparislerim'
            }"
          >
            <UIcon name="i-heroicons-shopping-bag" class="w-5 h-5" />
            <span class="text-sm">Siparişlerim</span>
          </div>
        </NuxtLink>

        <NuxtLink to="/hesap/adreslerim">
          <div
            class="flex items-center gap-2 p-2 rounded-lg duration-200 hover:bg-gray-50"
            :class="{
              'bg-orange-50 text-orange-600':
                useRoute().fullPath === '/hesap/adreslerim'
            }"
          >
            <UIcon name="i-heroicons-map-pin" class="w-5 h-5" />
            <span class="text-sm">Adreslerim</span>
          </div>
        </NuxtLink>

        <NuxtLink to="/hesap/favorilerim">
          <div
            class="flex items-center gap-2 p-2 rounded-lg duration-200 hover:bg-gray-50"
            :class="{
              'bg-orange-50 text-orange-600':
                useRoute().fullPath === '/hesap/favorilerim'
            }"
          >
            <UIcon name="i-heroicons-heart" class="w-5 h-5" />
            <span class="text-sm">Favorilerim</span>
          </div>
        </NuxtLink>

        <NuxtLink to="/hesap/ayarlar">
          <div
            class="flex items-center gap-2 p-2 rounded-lg duration-200 hover:bg-gray-50"
            :class="{
              'bg-orange-50 text-orange-600':
                useRoute().fullPath === '/hesap/ayarlar'
            }"
          >
            <UIcon name="i-heroicons-cog-6-tooth" class="w-5 h-5" />
            <span class="text-sm">Hesap Ayarları</span>
          </div>
        </NuxtLink>

        <!-- Çıkış Yap -->
        <div class="px-2 mt-2 pt-2 border-t border-gray-100">
          <button
            @click="authStore.logout()"
            class="flex items-center gap-2 w-full p-2 rounded-lg text-red-600 duration-200 hover:bg-red-50"
          >
            <UIcon
              name="i-heroicons-arrow-right-on-rectangle"
              class="w-5 h-5"
            />
            <span class="text-sm">Çıkış Yap</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const authStore = useAuthStore()
</script>
